<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
<div class="mobile-responsive">
  @if (!isFormSend) {
    <div class="card col-lg-3 col-11 mx-auto">
      <div class="card-body">
        <h4>Passwort festlegen</h4>
        <p>Geben Sie Ihr Passwort ein und bestätigen Sie es</p>
        <form [formGroup]="changePasswordForm" style="margin-top: 1.75rem" (ngSubmit)="onSubmit()">
          <label class="form-label w-100 mt-3">
            Passwort<i style="color: var(--main-error-color);">*</i>
            <i class="icon-info-o ms-2 mt-1 position-absolute" style="font-size: 12px;" [tooltip]="passwordInfo"></i>
            <div class="position-relative">
              <input noTrim [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" class="form-control" placeholder="•••••••••••••"
                  [style]="((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ) || changePasswordForm.get('password')!.hasError('required')
                  || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))
                && changePasswordForm.get('password')!.touched ? 'padding-left: 2.25rem;' : '' "
                  [ngClass]="((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) || changePasswordForm.get('password')!.hasError('required')
                  || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))
                && changePasswordForm.get('password')!.touched ? 'invalid' : '' " minlength="10">
              <i class="visibility-icon my-auto"
                [class.icon-visibility-on]="!isPasswordVisible"
                [class.icon-visibility-off]="isPasswordVisible"
                (click)="isPasswordVisible = !isPasswordVisible">
              </i>
              @if (((changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) || changePasswordForm.get('password')!.hasError('required')
                || changePasswordForm.get('password')!.hasError('minlength') || changePasswordForm.get('password')!.hasError('requiresSpecialChars'))
                && (changePasswordForm.get('password')!.touched || changePasswordForm.get('passwordConfirm')!.touched)) {
                <i class="icon-cancel"></i>
              }
            </div>
            @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched
              && !changePasswordForm.get('password')!.hasError('minlength') && !changePasswordForm.get('password')!.hasError('minlength')
              && !changePasswordForm.get('password')!.hasError('requiresSpecialChars')) {
              <span style="color: var(--main-error-color); font-size: 12px;font-weight: 600;">Die Passwörter sollten gleich sein</span>
            }
            @if (changePasswordForm.get('password')!.hasError('required') && changePasswordForm.get('password')!.touched) {
              <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Dieses Feld ist erforderlich.</span>
            }
            @if (changePasswordForm.get('password')!.hasError('minlength') && changePasswordForm.get('password')!.touched) {
              <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Ein Passwort muss aus mindestens zehn Zeichen bestehen.</span>
            }
            @if (changePasswordForm.get('password')!.hasError('requiresSpecialChars') && changePasswordForm.get('password')!.touched && !changePasswordForm.get('password')!.hasError('minlength')) {
              <span style="color: red; font-size: 12px;" class="mb-3">Das Passwort sollte mindestens ein Sonderzeichen enthalten.</span>
            }
          </label>
          <label class="form-label w-100 mt-3">
            Passwort bestätigen<i style="color: var(--main-error-color);">*</i>
            <div class="position-relative">
              <input noTrim [type]="isPasswordConfirmVisible ? 'text' : 'password'" formControlName="passwordConfirm" class="form-control" placeholder="•••••••••••••"
                [style]=" changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ? 'padding-left: 2.25rem;' : '' "
                [ngClass]="changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched ? 'invalid' : '' ">
              @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) {
                <i class="icon-cancel"></i>
              }
              <i class="visibility-icon my-auto"
                [class.icon-visibility-on]="!isPasswordConfirmVisible"
                [class.icon-visibility-off]="isPasswordConfirmVisible"
                (click)="isPasswordConfirmVisible = !isPasswordConfirmVisible">
              </i>
            </div>
            @if (changePasswordForm.errors?.['passwordMatching'] && changePasswordForm.get('passwordConfirm')!.touched) {
              <span style="color: var(--main-error-color); font-size: 12px; font-weight: 600;">Die Passwörter sollten gleich sein</span>
            }
          </label>
          <button type="submit" class="btn btn-primary d-block mx-auto" style="margin-top: 2rem; height: 2.5rem;" [disabled]="changePasswordForm.invalid">Einladung annehmen</button>
        </form>
      </div>
    </div>
  }
  @if (isFormSend) {
    <div style="margin-top: 8rem;" class="card col-lg-3 col-11 mx-auto">
      <div class="card-body">
        <div class="text-center">
          <span class="icon-check-circle"></span>
          <h4 style="margin-top: 2.5rem;">Ihr Passwort wurde gespeichert</h4>
          <small>Sie können sich nun mit Ihrem Passwort anmelden.</small>
        </div>
        <button type="button" class="btn btn-primary d-block mx-auto" style="margin-top: 2rem; height: 2.5rem;" (click)="GoToLogin()">Anmeldung</button>
      </div>
    </div>
  }
</div>
<footer class="text-center mt-2">
  <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span>
  <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum </a>
</footer>

<ng-template #passwordInfo>
  <div style="font-size: 14px;" class="text-start">Das Passwort muss die folgenden Anforderungen erfüllen:
    <ul>
      <li>Mindestens 10 Zeichen</li>
      <li>Mindestens ein Sonderzeichen wie !&#64;#$%^&*()_+</li>
    </ul>
  </div>
</ng-template>
